import React, { useEffect, useState } from "react";
import styles from "./transactiondetail.module.css";
import TransactionDetail from "./transactionDetail";
import { Row, Col, Button } from "react-bootstrap";
import NewHeader from "../NavBar/newHeader";
import Footer from "../../component/Footer/Footer";
import { useNavigate } from "react-router-dom";
import { useMyContext } from "../../myContext";
import bannerEducation from "../../public/assets/bannerEducation.png";
import greenCheck from "../../public/assets/greenCheck.svg";
import rightArrow from "../../public/assets/rightArrow.svg";
import crossIcon from "../../public/assets/icons-cross.svg";
import { createPlan, generateDirectQuote, userDetails } from "../../api";
import CashMgmtModal from "./CashMgmtModal";
import { Spinner } from "react-bootstrap";
import Dropdown from "../../component/Dropdown/dropdown";
import arrow from "../../public/assets/doubleSideArrow.svg";
import indiaflag from "../../public/assets/inflag.svg";
import { decimalAdjust } from "../../utils";
import { defaultCurrency } from "../../constant";

const TransactionPage = () => {
  const navigate = useNavigate();
  const {
    setUserStatus,
    planId,
    themeColor,
    loadingLogo,
    offlineTransactionFlow,
    partnerCode,
  } = useMyContext();
  const [isUserPlanAdded, setIsUserPlanAdded] = useState(false);
  const [loader, setLoader] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [currency, setCurrency] = useState(defaultCurrency);
  const [exRate, setExRate] = useState("--");

  const generateQuoteApi = () => {
    setExRate("--");
    const body = {
      amount: 1,
      fromCurrency: "INR",
      toCurrency: currency,
      inputCurrency: currency,
      panNo: "CVVPA1327A",
      planCd: planId,
      partnerCd: partnerCode,
    };
    try {
      generateDirectQuote(body).then((res) => {
        if (res.data) {
          const forexRate = decimalAdjust("floor", res.data.exRate, -2);
          setExRate(forexRate);
        }
      });
    } catch (error) {}
  };

  useEffect(() => {
    sessionStorage.setItem("nextStep", "");
    sessionStorage.setItem("purposeId", "");
    sessionStorage.setItem("subPurpose", "");
    sessionStorage.setItem("studentId", "");
    sessionStorage.setItem("remitterBankId", "");
    sessionStorage.setItem("remitterId", "");
    sessionStorage.setItem("beneficiaryName", "");
    sessionStorage.setItem("beneficiaryBankId", "");
    sessionStorage.setItem("transactionID", "");
    sessionStorage.setItem("purpose", "");
    sessionStorage.setItem("country", "");
    sessionStorage.setItem("AmountConversion", "");
    sessionStorage.setItem("accountDetail", "");
    sessionStorage.setItem("currencyCode", "");
    sessionStorage.setItem("EducationLoan", "");
  },[]);

  const userDataApi = () => {
    setIsUserPlanAdded(true);
  };

  useEffect(() => {
    getUserDetails();
    setUserStatus("transaction-detail");
    userDataApi();
    if (offlineTransactionFlow === true) {
      sessionStorage.setItem("offlineUserStatus", "transactionDetail");
    } else {
      generateQuoteApi();
    }
  }, [partnerCode]);

  useEffect(() => {
    generateQuoteApi();
  }, [currency]);

  const startSendMoney = () => {
    if (offlineTransactionFlow === true) {
      sessionStorage.setItem("offlineUserStatus", "offlineOnboarding");
      navigate("/offline-onboarding");
    } else {
      sessionStorage.setItem("purpose", "Education");
      navigate("/purpose");
    }
  };

  const getUserDetails = async () => {
    try {
      userDetails().then((resp) => {
        if (resp.status == 200 && resp.data) {
          if (resp.data.status == "APPROVED") {
            setIsUserPlanAdded(true);
          } else {
            setIsUserPlanAdded(false);
          }
        } else {
          setIsUserPlanAdded(false);
        }
      });
    } catch (err) {
      setIsUserPlanAdded(false);
    }
  };

  const ErrorModal = () => {
    return (
      <div className={styles.errorContainer}>
        <img src={crossIcon} alt="" style={{ height: "75px", width: "75px" }} />
        <p className={styles.message}>{errorMessage}</p>
      </div>
    );
  };

  const openErrorModal = () => {
    setShowErrorModal(!showErrorModal);
  };

  useEffect(() => {
    if (showErrorModal) {
      setTimeout(() => {
        setShowErrorModal(false);
      }, 4000);
    }
  }, [showErrorModal]);

  const handleChangeOption = (value) => {
    setCurrency(value);
  };

  return (
    <>
      <NewHeader show={true} />
      <CashMgmtModal showModal={showErrorModal} openModal={openErrorModal}>
        <ErrorModal />
      </CashMgmtModal>
      {/* {loading ? (
        <Spinner animation="border" className={styles.spinnerColorOutside} style={{borderColor: themeColor, borderRightColor: "#eaecf0"}} />
      )  */}
      {!loadingLogo ? (
        <Spinner
          animation="border"
          className={styles.spinnerColorOutside}
          style={{ borderColor: themeColor, borderRightColor: "#eaecf0" }}
        />
      ) : (
        <div className={`container ${styles.mainContainer}`}>
          <Row className={styles.topContainer}>
            <Col
              xl={7}
              lg={6}
              md={12}
              className={`${styles.leftContainer} ${
                offlineTransactionFlow === true ? styles.leftContainerXotic : ""
              } `}
            >
              <p
                className={`${styles.leftContainerHeading} ${
                  offlineTransactionFlow === true
                    ? styles.leftContainerHeadingXotic
                    : ""
                } `}
              >
                {offlineTransactionFlow === true
                  ? "Send money to Russia for Educational expenses"
                  : "Send money abroad for Educational expenses"}
              </p>
              {offlineTransactionFlow === true ? (
                ""
              ) : (
                <Row style={{ marginLeft: "32px" }}>
                  <Col md={3} className={styles.checkMarkDiv}>
                    <Row className={styles.description}>
                      <img
                        className={styles.greenCheck}
                        src={greenCheck}
                        alt=""
                      />
                      Rental Payments
                    </Row>
                    <Row className={styles.description}>
                      <img
                        src={greenCheck}
                        className={styles.greenCheck}
                        alt=""
                      />
                      Tuition Fees
                    </Row>
                  </Col>
                  <Col md={3} className={styles.checkMarkDiv}>
                    <Row className={styles.description}>
                      <img
                        className={styles.greenCheck}
                        src={greenCheck}
                        alt=""
                      />
                      Blocked Account
                    </Row>
                    <Row className={styles.description}>
                      <img
                        src={greenCheck}
                        className={styles.greenCheck}
                        alt=""
                      />
                      GIC Account
                    </Row>
                  </Col>
                </Row>
              )}
              {loadingLogo ? (
                <>
                  {" "}
                  {loader ? (
                    <Button className={styles.sendMoneyButton}>
                      <Spinner
                        animation="border"
                        className={styles.whiteSpinnerColor}
                        style={{
                          color: "white",
                          borderColor: themeColor,
                          borderRightColor: "white",
                        }}
                      />
                    </Button>
                  ) : (
                    <Button
                      className={`${styles.sendMoneyButton} ${
                        offlineTransactionFlow === true
                          ? styles.sendMoneyButtonXotic
                          : ""
                      } `}
                      // onClick={() => {
                      //   isUserPlanAdded ? startSendMoney() : verifyWithPlan()
                      // }}
                      onClick={() => startSendMoney()}
                      style={{
                        backgroundColor: themeColor,
                        border: "0px",
                      }}
                    >
                      Send Money
                      <img
                        className={styles.rightArrow}
                        src={rightArrow}
                        alt=""
                      />
                    </Button>
                  )}
                </>
              ) : (
                <Button
                  className={`${styles.sendMoneyButton} ${
                    offlineTransactionFlow === true
                      ? styles.sendMoneyButtonXotic
                      : ""
                  } `}
                  style={{
                    backgroundColor: "#F9FAFB",
                    border: "0px",
                    color: "#F9FAFB",
                  }}
                >
                  Send Money
                </Button>
              )}
              {offlineTransactionFlow === true ? (
                ""
              ) : (
                <div className={styles.conversionDiv}>
                  <div className={styles.conversionRateDiv}>
                    Conversion Rate
                  </div>
                  <div className={styles.currencyConversionDiv}>
                    <div className={styles.dropdownDiv}>
                      <Dropdown
                        label=""
                        heading=""
                        onChange={handleChangeOption}
                        styling={"transactionPage"}
                      />
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <img src={arrow} alt=""></img>
                    </div>
                    <div
                      className={styles.dropdownDiv}
                      style={{ marginLeft: "10px" }}
                    >
                      <div className={styles.customDiv}>
                        <>
                          <img
                            src={indiaflag}
                            alt=""
                            className={styles.imagedivtransaction}
                          />
                          <div className={styles.currency}>
                            {exRate}{" "}
                            <span
                              style={{ position: "absolute", right: "16px" }}
                            >
                              {" "}
                              INR
                            </span>
                          </div>
                        </>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </Col>
            <Col xl={5} lg={6} md={12} className={styles.rightContainer}>
              <img
                src={bannerEducation}
                className={styles.rightImageContainer}
                alt=""
              ></img>
            </Col>
          </Row>
          <TransactionDetail />
        </div>
      )}
      <Footer />
    </>
  );
};

export default TransactionPage;
